<div class="snackbar-wrapper" *ngIf="showSnackbar">
    <div class="snackbar-container">
        <mat-icon svgIcon="info" class="snackbar-icon" />
        <div class="snackbar-text">
            {{ "snackbar.disconnected-status.text" | translate }}
        </div>
        <div class="snackbar-button" (click)="goToStatusPage()">
            {{ "snackbar.disconnected-status.button" | translate }}
        </div>
    </div>
</div>
